import { useEffect, useState } from "react";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Button,
  List,
  ListSubheader,
  Typography,
} from "@mui/material";
import "../Dashboard/Dashboard.css";
import FilterAltOutlinedIcon from "@mui/icons-material/FilterAltOutlined";
import ApiServices from "../../services/ApiServices";
import Tooltip from "../../common/workarounds/tooltip/PatchTooltip";
import BorderColorIcon from "@mui/icons-material/BorderColor";
import { APPROVAL_LIST } from "../../constants/api-constants";
import Popover from "@mui/material/Popover";
import { toast } from "react-toastify";
import { useLoading } from "../../hooks/useLoader";
import { ClearSelectionData } from "../../utilities/SelectionFilter";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import CheckboxList from "../../common/CheckboxList/CheckboxList";
import DataTable from "../Tables/DataTable/DataTable";
import { execeptionMessage } from "../../constants/common";
import TableColumnModal from "../../common/TableColumnModal/TableColumnModal";
import { useHistory } from "react-router";
import { useAuth } from "../../hooks/useAuth";
import { useApprovalContext } from "./Approval.context";
import {
  SystemModulesEnum,
  SystemUsersEnum,
} from "../../constants/SystemUsers";
import { PermissionService } from "../../constants/permissionService";
import { MenuListItems } from "../../common/Sidebar/MenuListItems";
import ConfirmationWithRejectReason from "../../common/ConfirmationWithRejectReason/ConfirmationWithRejectReason";
import { AssociationStatusEnum } from "../../common/Modal/AssociationStatusEnum";
import { useMasterData } from "../../hooks/useMasterData";
/*istanbul ignore next */
const ApprovaRequests = (props) => {
  const { showLoader } = useLoading();
  const [adminTable, setAdminTableData] = useState([]);
  const [tableColumnModalVisibility, setTableColumnModalVisibility] =
    useState(false);
  const [selectedColumns, setSelectedColumns] = useState([]);
  const [totalPages, setTotalPages] = useState(0);
  const [pageSize, setPageSize] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedStatus, setSelectedStatus] = useState([]);
  const [selectedApplicable, setSelectedApplicable] = useState([]);
  const auth = useAuth();
  const currentUser = auth.getCurrentUser();
  const userSelectedRoleId = Number(localStorage.getItem("selectedRole"));
  const userId =
    userSelectedRoleId === SystemUsersEnum.SUPERADMIN ||
    userSelectedRoleId === SystemUsersEnum.ADMIN
      ? 0
      : currentUser.userId;

  const filterOptions = [];
  const approvalTypes = [];

  const ApprovalTypeEnum = {
    AssociationRequest: 1,
    NewRegistration: 2,
  };

  if (
    auth.getRole() === SystemUsersEnum.SUPERADMIN ||
    auth.getRole() === SystemUsersEnum.ADMIN
  ) {
    filterOptions.push(
      { value: 1, label: "Association Request" },
      { value: 2, label: "New Registration" }
    );
    approvalTypes.push(1, 2);
  } else {
    filterOptions.push({ value: 1, label: "Association Request" });
    approvalTypes.push(1);
  }

  const [query, setQuery] = useState({
    searchText: "",
    PageSize: 10,
    PageNumber: 1,
    IgnorePaging: false,
    SortColumn: "createdOn",
    SortType: "desc",
    Filter: { approvalType: approvalTypes, status: [1, 3, 2] },
  });

  const [anchorEl, setAnchorEl] = useState(null);
  const [expanded, setExpanded] = useState("false");
  const [confirmation, setConfirmation] = useState(false);
  const [isReadOnlyReason, setIsReadOnlyReason] = useState(false);
  const [additionalDetails, setAdditionalDetails] = useState("");
  const [rejectReasonId, setRejectReasonId] = useState(0);
  const [isAssociationReq, setIsAssociationReq] = useState(false);
  const [reasonOptions, setReasonOptions] = useState([]);
  const filterAccordianHandleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  let moduleId = MenuListItems.find(
    (item) => item.name === SystemModulesEnum.APPROVAL
  ).moduleId;
  const permissions = PermissionService(moduleId);
  const masterDataContext = useMasterData();
  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  useEffect(() => {
    setSelectionColumns();
    approvalDetails();
    ClearSelectionData();
  }, [query]);

  useEffect(() => {
    const response = masterDataContext.masterDataValue;
    setReasonOptions(
      response?.result?.masterData.map((option) => {
        return {
          value: option.masterDataId,
          name: option.name,
        };
      })
    );
  }, []);

  const handleChangePageNumber = (event, newPage) => {
    setCurrentPage(newPage);
    setQuery((prevState) => {
      return { ...prevState, PageNumber: newPage };
    });
  };

  const pageSizeChangeHandler = (PageSize) => {
    setQuery((prevState) => {
      return { ...prevState, PageSize: PageSize, PageNumber: 1 };
    });
  };

  const history = useHistory();
  const approvalContext = useApprovalContext();

  const onView = (approval) => {
    approval.editable = false;
    approvalContext.setEditMode(false);

    // For "Association Request" redirect to route "confirm-approval" oterwise "confirm-signup"
    const routePath =
      approval.approvalType === 1 ? "confirm-approval" : "confirm-signup";
    history.push(`/${routePath}/${approval.userId}/${approval.approvalId}`);
  };

  const onEdit = (approval) => {
    approval.editable = true;
    approvalContext.setEditMode(true);
    // For "Association Request" redirect to route "confirm-approval" oterwise "confirm-signup"
    const routePath =
      approval.approvalType === 1 ? "confirm-approval" : "confirm-signup";
    history.push(`/${routePath}/${approval.userId}/${approval.approvalId}`);
  };

  const handleConfirmationClose = () => {
    setIsReadOnlyReason(false);
    setConfirmation(false);
    setAdditionalDetails("");
  };
  const onReject = (data) => {
    setConfirmation(true);
    setIsReadOnlyReason(true);

    if (data.approvalType === ApprovalTypeEnum.AssociationRequest) {
      setIsAssociationReq(true);
      setAdditionalDetails(data.rejectReason);
    } else {
      setIsAssociationReq(false);
      let rReasons =
        data.rejections && data.rejections.length > 0 && data.rejections[0];
      setAdditionalDetails(rReasons.additionalDetails);
      setRejectReasonId(rReasons.rejectReasonId);
    }
  };

  const approvalDetails = async () => {
    try {
      showLoader(true);
      const adminData = await ApiServices.httpGet(
        `${APPROVAL_LIST}/${userId}/${JSON.stringify(query)}`
      );
      showLoader(false);
      setAdminTableData(adminData?.result?.records);
      setTotalPages(adminData?.result?.totalPages);
      setPageSize(adminData?.result?.pageSize);
      setCurrentPage(adminData?.result?.currentPage);
    } catch (e) {
      showLoader(false);
      toast.error(execeptionMessage);
    }
  };

  const onSearchHandler = (event) => {
    ClearSelectionData();
    setTimeout(() => {
      setQuery((prevState) => {
        return {
          ...prevState,
          PageNumber: 1,
          searchText: event.target.value,
        };
      });
    }, 1000);
  };

  const sortHandler = (sortOrder, sortBy) => {
    setQuery((prevState) => {
      if (prevState.SortColumn === sortBy) {
        return {
          ...prevState,
          SortType: sortOrder === "asc" ? "desc" : "asc",
        };
      } else {
        return {
          ...prevState,
          SortColumn: sortBy,
          SortType: "asc",
        };
      }
    });
  };

  const onFilterRoleChangeHandler = (values) => {
    setSelectedApplicable(values);
  };

  const onFilterStatusChangeHandler = (values) => {
    setSelectedStatus(values);
  };

  const applyFilterHandler = () => {
    ClearSelectionData();
    setQuery((prevState) => {
      return { ...prevState, PageNumber: 1 };
    });
    setQuery((prevState) => {
      return {
        ...prevState,
        PageNumber: 1,
        Filter: {
          ...prevState.filter,
          approvalType: selectedApplicable,
          status: selectedStatus,
        },
      };
    });
  };

  const clearFilterHandler = () => {
    setQuery((prevState) => {
      return { ...prevState, PageNumber: 1 };
    });
    setSelectedApplicable([]);
    setSelectedStatus([]);
  };

  const onCancelTableColumnSelection = () => {
    setTableColumnModalVisibility(false);
    setSelectionColumns();
  };

  const onSaveTableColumnSelection = (componentName, columns) => {
    let oldData = localStorage.getItem("selectedColumns")
      ? JSON.parse(localStorage.getItem("selectedColumns"))
      : null;
    if (oldData) {
      let data = { ...oldData, approval: columns };
      localStorage.setItem("selectedColumns", JSON.stringify(data));
    }
    setSelectionColumns();
    setTableColumnModalVisibility(false);
  };

  const setSelectionColumns = () => {
    let selectedCols = localStorage.getItem("selectedColumns")
      ? JSON.parse(localStorage.getItem("selectedColumns"))
      : null;
    let adminCols = selectedCols.approval ? selectedCols.approval : null;
    if (adminCols) {
      setSelectedColumns(adminCols);
    }
  };

  return (
    <div className="dashboard-main">
      <div
        className="menu-bar"
        style={{
          display: "flex",

          height: "100%",
        }}
      >
        <div className="welcome">
          <div className="welcome-main">
            <div className="welcome-message">
              {auth.getRole() === SystemUsersEnum.DISTRIBUTOR ? (
                <h5>Enterprise Group Approval</h5>
              ) : (
                <h5>Approvals</h5>
              )}
            </div>
            <div className="welcome-widgets">
              <div>
                <Popover
                  anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "right",
                  }}
                  transformOrigin={{
                    vertical: "top",
                    horizontal: "right",
                  }}
                  id={id}
                  open={open}
                  anchorEl={anchorEl}
                  onClose={handleClose}
                >
                  <div className="expanded-filter">
                    <div className="filter-options">
                      <List
                        sx={{
                          width: "100%",
                          maxWidth: 360,
                          bgcolor: "background.paper",
                        }}
                        component="nav"
                        aria-labelledby="nested-list-subheader"
                        subheader={
                          <ListSubheader
                            component="div"
                            id="nested-list-subheader"
                          >
                            Filters will be applied to your grid
                          </ListSubheader>
                        }
                      >
                        {auth.getRole() !== SystemUsersEnum.DISTRIBUTOR && (
                          <Accordion
                            expanded={expanded === "role"}
                            onChange={filterAccordianHandleChange("role")}
                          >
                            <AccordionSummary
                              expandIcon={<ExpandMoreIcon />}
                              aria-controls="panel1bh-content"
                              id="panel1bh-header"
                              className="accordion-summary"
                            >
                              <Typography sx={{ flexShrink: 0 }}>
                                Request Type
                              </Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                              <CheckboxList
                                id="role"
                                options={filterOptions}
                                onChange={onFilterRoleChangeHandler}
                                selectedValues={selectedApplicable}
                              />
                            </AccordionDetails>
                          </Accordion>
                        )}
                        <Accordion
                          expanded={expanded === "status"}
                          onChange={filterAccordianHandleChange("status")}
                        >
                          <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel1bh-content"
                            id="panel1bh-header"
                          >
                            <Typography sx={{ flexShrink: 0 }}>
                              Status
                            </Typography>
                          </AccordionSummary>
                          <AccordionDetails>
                            <CheckboxList
                              id="status"
                              options={[
                                { value: 1, label: "Approved" },
                                { value: 2, label: "Rejected" },
                                { value: 3, label: "Pending" },
                              ]}
                              onChange={onFilterStatusChangeHandler}
                              selectedValues={selectedStatus}
                            />
                          </AccordionDetails>
                        </Accordion>
                      </List>
                    </div>
                    <div className="modal-footer">
                      <Button
                        variant="outlined"
                        className="action-button mr-4"
                        onClick={clearFilterHandler}
                      >
                        Clear
                      </Button>
                      <Button
                        variant="contained"
                        className="action-button"
                        onClick={() => {
                          applyFilterHandler();
                          handleClose();
                        }}
                      >
                        Apply
                      </Button>
                    </div>
                  </div>
                </Popover>
              </div>

              <Tooltip placement="bottom" title="Filter">
                <FilterAltOutlinedIcon onClick={handleClick} />
              </Tooltip>

              <Tooltip placement="bottom" title="Change View">
                <BorderColorIcon
                  onClick={() => {
                    setTableColumnModalVisibility(true);
                  }}
                  data-testid="TableColumnSelectionIcon"
                />
              </Tooltip>
            </div>
          </div>

          <DataTable
            uniqueKey="requestId"
            columns={selectedColumns}
            query={query}
            handleChangePage={handleChangePageNumber}
            adminTable={adminTable}
            totalPages={totalPages}
            pageSize={pageSize}
            onSearch={onSearchHandler}
            onSort={sortHandler}
            onPageSizeChange={pageSizeChangeHandler}
            showView={true}
            showEdit={true}
            onEdit={(data) => onEdit(data)}
            onView={(data) => onView(data)}
            onReject={(data) => onReject(data)}
            page={currentPage}
            checkboxesNotRequired={true}
            permissions={permissions}
          />

          {tableColumnModalVisibility && (
            <TableColumnModal
              isOpen={tableColumnModalVisibility}
              onCancelTableColumnSelection={onCancelTableColumnSelection}
              onSaveTableColumnSelection={onSaveTableColumnSelection}
              selection={selectedColumns}
            />
          )}
          <ConfirmationWithRejectReason
            open={confirmation}
            handleClose={handleConfirmationClose}
            showReason={true}
            onCancel={() => {
              handleConfirmationClose();
            }}
            title={"Reason for Rejection:"}
            isReadOnlyReason={isReadOnlyReason}
            isAssociationReq={isAssociationReq}
            actionName={AssociationStatusEnum.Rejected}
            additionalDetails={additionalDetails}
            rejectReasonId={rejectReasonId}
            options={reasonOptions}
          />
        </div>
      </div>
    </div>
  );
};

export default ApprovaRequests;
